import { Type as T } from '@sinclair/typebox';
import { Value } from '@sinclair/typebox/value';
import { validateField } from '../index.js';

export const CreateFacilitySchema = T.Object({
  responsibleUser: T.String({ format: 'uuid', error: 'Usuário responsável é um campo obrigatório' }),
  name: T.String({ minLength: 1, error: 'Nome do estabelecimento é um campo obrigatório' }),
  cnpj: T.Intersect([
    T.String({ error: 'O campo cnpj é obrigatório' }),
    T.String({ format: 'cnpj', error: 'O cnpj é inválido' }),
  ]),
  cep: T.Intersect([
    T.String({ error: 'O campo cep é obrigatório' }),
    T.String({ format: 'cep', error: 'O formato é inválido' }),
  ]),
  address: T.String({ minLength: 1, maxLength: 80, error: 'Endereço é obrigatório' }),
  district: T.String({ minLength: 1, maxLength: 80, error: 'Bairro é obrigatório' }),
  number: T.String({ minLength: 1, maxLength: 80, error: 'Número é obrigatório' }),
  city: T.String({ minLength: 1, maxLength: 80, error: 'Cidade é obrigatória' }),
  state: T.String({ minLength: 1, maxLength: 80, error: 'UF inválida' }),
  cityIbgeCode: T.String({ minLength: 1, maxLength: 80, error: 'Código Ibge da cidade é obrigatório' }),
  complement: T.Optional(T.String({ maxLength: 80, error: 'Complemento muito longo' })),
  referenceLocation: T.Optional(T.String({ maxLength: 255, error: 'Ponto de referência muito longo' })),
  fileType: T.Optional(T.String({ error: 'Imagem é obrigatória' })),
  /** Pre-uploaded image key from image.uploadCompressed endpoint */
  imageKey: T.Optional(T.String()),
  latitude: T.Optional(T.Number()),
  longitude: T.Optional(T.Number()),
});

export type CreateFacilityInputType = typeof CreateFacilitySchema.static;

export async function ValidateCreateFacilityInput(value: unknown): Promise<CreateFacilityInputType> {
  return Value.Parse(CreateFacilitySchema, value);
}

export function checkFacilityCreateInput(field: string, value: unknown): string | boolean {
  return validateField(CreateFacilitySchema, field, value);
}
